import { ComponentType, lazy } from "react";

type ModuleImport<T = any> = () => Promise<{ default: ComponentType<T> }>;

const RELOAD_KEY = "chunk_reload_attempted";

export function lazyWithRetry<T = any>(importFn: ModuleImport<T>) {
  return lazy(() =>
    importFn().catch(() => {
      return new Promise<{ default: ComponentType<T> }>((resolve, reject) => {
        setTimeout(() => {
          importFn()
            .then(resolve)
            .catch(() => {
              const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
              if (!hasReloaded) {
                sessionStorage.setItem(RELOAD_KEY, "true");
                window.location.reload();
                return new Promise(() => {});
              }
              sessionStorage.removeItem(RELOAD_KEY);
              reject(new Error("Failed to load application chunk after retry"));
            });
        }, 1000);
      });
    }),
  );
}
